import {
  CreatePythonFunctionRequest,
  PythonFunction,
  PythonFunctionSummary,
  UpdatePythonFunctionRequest,
  WorkflowNode,
} from 'api/model';
import instance from '../axios_instance';

export const getProjectList = async (
  projectId: string,
  includeGlobal: boolean,
  unusedOnly = false,
): Promise<PythonFunctionSummary[]> => {
  const params = new URLSearchParams({ view: 'summary' });
  if (includeGlobal) params.set('include_global', 'true');
  if (unusedOnly) params.set('unused_only', 'true');
  const url = `/projects/${projectId}/python-functions?${params.toString()}`;
  const response = await instance.get<PythonFunctionSummary[]>(url);
  return response.data;
};

export const getGlobalList = async (unusedOnly = false): Promise<PythonFunctionSummary[]> => {
  const params = new URLSearchParams({ view: 'summary' });
  if (unusedOnly) params.set('unused_only', 'true');
  const response = await instance.get<PythonFunctionSummary[]>(`/python-functions?${params.toString()}`);
  return response.data;
};

export const get = async (id: string, revision?: number): Promise<PythonFunction> => {
  const url = revision ? `/python-functions/${id}/revision/${revision}` : `/python-functions/${id}`;
  const response = await instance.get<PythonFunction>(url);
  return response.data;
};

export const create = async (model: CreatePythonFunctionRequest): Promise<PythonFunction> => {
  const response = await instance.post<PythonFunction>(`/python-functions`, model);
  return response.data;
};

export const update = async (id: string, model: UpdatePythonFunctionRequest): Promise<PythonFunction> => {
  const response = await instance.put<PythonFunction>(`/python-functions/${id}`, model);
  return response.data;
};

export const remove = async (id: string) => {
  return await instance.delete(`/python-functions/${id}`);
};

export const getNodesUsingFunction = async (functionId: string) => {
  const response = await instance.get<WorkflowNode[]>(`/python-functions/${functionId}/nodes`);
  return response.data;
};

export const getGlobalFolders = async (): Promise<string[]> => {
  const response = await instance.get<string[]>('/python-functions/folders');
  return response.data;
};

export const getProjectFolders = async (projectId: string, includeGlobal: boolean): Promise<string[]> => {
  const params = includeGlobal ? '?include_global=true' : '';
  const response = await instance.get<string[]>(`/projects/${projectId}/python-functions/folders${params}`);
  return response.data;
};
